import React, { useState } from 'react';
import { Check, ChevronDown, Search } from 'lucide-react';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "../components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../components/ui/popover";
import { Button } from "../components/ui/button";

interface CompanySearchDropdownProps {
  currentCompany: string;
  onCompanySelect: (company: { id: string; name: string; cin: string }) => void;
  companies: { id: string; name: string; cin: string }[];
}

export default function CompanySearchDropdown({ currentCompany, onCompanySelect,companies }: CompanySearchDropdownProps) {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const filteredCompanies = companies.filter(company =>
    company.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelect = (company: typeof companies[0]) => {
    onCompanySelect(company);
    setOpen(false);
    setSearchValue("");
  };

  return (
    <Popover open={open} onOpenChange={setOpen} >
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          role="combobox"
          aria-expanded={open}
          className="justify-between p-0 h-auto font-normal text-left z-2"
        >
          <span className="text-sm company-dropdown-current hover:bg-[rgba(24,24,15,0.1)] transition-colors duration-150 cursor-pointer p-0.5">{currentCompany}</span>
          <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[400px] p-0" align="start">
        <Command className='bg-white'>
          <CommandInput 
            placeholder="Search companies..." 
            value={searchValue}
            onValueChange={setSearchValue}
          />
          <CommandList className='bg-white'>
            <CommandEmpty>No companies found.</CommandEmpty>
            <CommandGroup>
              {filteredCompanies.map((company:any) => (
                <CommandItem
                  key={company.id}
                  value={company.name}
                  onSelect={() => handleSelect(company)}
                  className="cursor-pointer hover:bg-[#f8f6f1]"
                  
                >
                  <div className="flex flex-col">
                    <span className="text-xs ">{company.name}</span>
                    <span className="text-xs text-muted-foreground">{company.cin}</span>
                  </div>
                  <Check
                    className={`ml-auto h-4 w-4 ${
                      company.name === currentCompany ? "opacity-100" : "opacity-0"
                    }`}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
